<template lang="html">
  <div id="data-sheet-page">
    <div class="container oversized-container main-container">
      <div class="row">
        <div class="col-12 col-main-options">
          <div class="d-left">
            <a class="btn btn-s1 bg-cprimary btn-small" @click="$refs['modal-share'].show();">Compartir <i class="fal fa-share-alt ic"></i></a>
            <a class="btn btn-s1 bg-cprimary btn-small" @click="$refs['modal-qr'].show()">QR <i class="fal fa-qrcode ic"></i></a>
            <a class="btn btn-s1 bg-cprimary btn-small"  @click="openPdf();" target="_blank">COA <i class="fal fa-file-pdf ic"></i></a>
          </div>

          <div class="d-right">
            <!-- <router-link class="btn btn-s1 bg-cprimary btn-small" to="/comparar">Comparar <i class="fas fa-not-equal ic"></i></router-link> -->
            <a class="btn btn-s1 bg-cprimary btn-small" @click="saveAction()">Guardar <i class="fal fa-save ic"></i></a>
          </div>
          <br><br>
          <h2>{{ row.ide }}</h2>
        </div>

        <div class="col-lg-4 col-content">
          <div class="box-inside to-wrap-al">
            <div class="b-aligned">
              <p class="text-center mb-4">
                <img :src="row.imageUrlBrand">
              </p>

              <p>
                <span class="txt-green f-w-700">CLIENTE: </span> {{ row.customer }}
              </p>
              <p>
                <span class="txt-green f-w-700">NÚMERO DE REPORTE: </span> {{ row.ide }}
              </p>
              
              <p>
                <span class="txt-green f-w-700">FECHA DEL REPORTE: </span> {{row.created}}
              </p>
              <p>
                <span class="txt-green f-w-700">VIGENTE HASTA: </span> <span class="ml-2">{{row.expiration_date}}</span>
                
              </p>
              <p>
                <span class="txt-green f-w-700">CIFRADO: </span> {{ row.encrypted_string }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-content">
          <div class="box-inside">
            <h6 class="mb-3 title">DESCRIPCIÓN DEL PRODUCTO</h6>
            <p class="p-md">
              {{ row.sample_description }}
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-content">
          <div class="box-inside">
            <h6 class="mb-3 title">DONDE COMPRAR</h6>

            <div class="box-logos">
              <div class="col-sm-4 col-lg-5 col-xl-4 col-logo" v-for="(img,indx) in row.stores" :key="indx">
                <a :href="img.link"b target="_blank">
                  <img :src="img.imageUrl" style="max-width: 100%;">
                </a>
               
              </div>

              <!-- <div class="col-sm-4 col-lg-5 col-xl-4 col-logo">
                <img src="public/images/pages/data-sheet/cannaland.jpg">
              </div>

              <div class="col-sm-4 col-lg-5 col-xl-4 col-logo">
                <img src="public/images/pages/data-sheet/cannatlan.jpg">
              </div> -->
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-content">
          <div class="box-inside">
            <div class="box-product-t1">
              <img :src="row.imageUrl">
            </div>
            <h6 class="mb-2 f-w-400">
              {{ row.customer_reference }}
            </h6>

            <p>
              <span class="txt-green f-w-700">ID del producto: </span> {{ row.ide_sample }}
            </p>
            <p>
              <span class="txt-green f-w-700">Descripción del: </span> {{ row.sample_description }}
            </p>
            <p>
              <span class="txt-green f-w-700">Referencia del cliente: </span> {{ row.customer_reference }}
            </p>
            <p>
              <span class="txt-green f-w-700">Muestréo: </span> {{ row.sampling }}
            </p>
            <p>
              <span class="txt-green f-w-700">Fecha de llegada/Transportado: </span> {{ row.arrival_date }}
            </p>
            <p>
              <span class="txt-green f-w-700">Estado de la muestra: </span> {{ row.status_sample}}
            </p>
            <p>
              <span class="txt-green f-w-700">Sellado: </span> {{ row.sealed}}
            </p>
            <p>
              <span class="txt-green f-w-700">Temperatura de la muestra: </span> {{ row.temperature}}
            </p>
            <p>
              <span class="txt-green f-w-700">Tiempo de almacenaje: </span> {{ row.storage_time}}
            </p>
            <p>
              <span class="txt-green f-w-700">Recipiente de la muestra: </span> {{ row.sample_container}}
            </p>
            <p>
              <span class="txt-green f-w-700">Inicio de analisis: </span> {{ row.start_analysis}}
            </p>
            <p>
              <span class="txt-green f-w-700">Término de analisis: </span> {{ row.end_analysis}}
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-content">
          <div class="box-inside">
            <h6 class="mb-3 title">CANNABINOIDES</h6>

            <p>
              <span class="txt-green f-w-700">Analisis solicitados: </span>
            </p>
            <p>
              <span class="txt-green f-w-700">Medición de cannabinoides (MCR001): </span>
            </p>
            <p>
              <span class="txt-green f-w-700">Método interno basado en *DAB 2018: </span>
            </p>
            <p>
              <span class="txt-green f-w-700">Cannabisblüten * (U-HPLC): </span>
            </p>

            <h6 class="mt-4 text-center f-w-400">
              PERFIL DE CANNABINOIDES
            </h6>

            <img :src="row.chartImage" width="100%">
          </div>
        </div>

        <div class="col-lg-4 col-content">
          <div class="box-inside">
            <h6 class="mb-3 title">CANNABINOIDES</h6>

            <div class="box-carousel-info">
              <swiper class="swiper" :options="infoOptions">
                <swiper-slide>
                  <div class="box-info">
                    <h3 class="txt-lg">{{row.piece_thc}}</h3>
                    <h5 class="mb-1 title-md">Total</h5>
                    <h5 class="title-md">{{row.piece_thc_title}}</h5>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="box-info">
                    <h3 class="txt-lg">{{row.pice_cbd}}</h3>
                    <h5 class="mb-1 title-md">Total</h5>
                    <h5 class="title-md">{{row.pice_cbd_title}}</h5>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="box-info">
                    <h3 class="txt-lg">{{row.piece_cbg}}</h3>
                    <h5 class="mb-1 title-md">Total</h5>
                    <h5 class="title-md">{{row.piece_cbg_title}}</h5>
                  </div>
                </swiper-slide>
                <!-- <swiper-slide>
                  <div class="box-info">
                    <h3 class="txt-lg">0.000<small>%</small></h3>
                    <h5 class="mb-1 title-md">Total</h5>
                    <h5 class="title-md">Potential THC</h5>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="box-info">
                    <h3 class="txt-lg">75.180<small>%</small></h3>
                    <h5 class="mb-1 title-md">Total</h5>
                    <h5 class="title-md">Potential CBD</h5>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="box-info">
                    <h3 class="txt-lg">NT<small>%</small></h3>
                    <h5 class="mb-1 title-md"></h5>
                    <h5 class="title-md">Moisture</h5>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="box-info">
                    <h3 class="txt-lg">Example<small>%</small></h3>
                    <h5 class="mb-1 title-md">xxxxx</h5>
                    <h5 class="title-md">xxxxx</h5>
                  </div>
                </swiper-slide> -->

                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>

            <div class="table-responsive box-table">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-center" colspan="3">Cuantificación de Cannabinoides</th>
                  </tr>
                  <tr class="f-w-600">
                    <th>Compuesto</th>
                    <th>mg/mL</th>
                    <th>%</th>
                    
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(det,indx) in row.details" :key="indx">
                    <td>{{det.analytical}}</td>
                    <td>{{det.mg}}</td>
                    <td>{{det.percent}}</td>
                   
                  </tr>

                  <tr>
                    <td>Total</td>
                    <td>{{ row.total_detail }}</td>
                    <td>{{ row.total_percent_detail }}</td>
                   
                  </tr>
                  <tr>
                    <td colspan="3">*CUANTIFICACIÓN DE LOS ANALITOS FUERA DEL ALCANCE DE LA CERTIFICACIÓN</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- <div class="col-lg-4 col-content">
          <div class="box-inside">
            <h6 class="mb-3 title">{{row.typecertificate}}</h6>

            <p class="text-center">
              <span class="approved">APROBADO</span>
            </p>
          </div>
        </div> -->

        <!-- <div class="col-lg-4 col-content">
          <div class="box-inside">
            <h6 class="mb-3 title">TERPENOS</h6>
          </div>
        </div>

        <div class="col-lg-4 col-content">
          <div class="box-inside">
            <h6 class="mb-3 title">METALES PESADOS</h6>

            <p class="text-center">
              <span class="approved">APROVADO</span>
            </p>
          </div>
        </div> -->
      
        <!-- <div class="col-lg-12 col-content">
          <div class="box-inside">
              <h6 class="mb-3 title">DOCUMENTACION</h6>
              <p class="p-md" v-for="(doc,indx) in row.docs" :key="indx"> <a :href="doc.documentUrl" target="_blank"> {{ doc.document_name }}</a></p>
          </div>
            
        </div>   -->

        <div class="col-lg-12 col-content">
          <div class="box-inside">
            <h6 class="mb-3 title">DOCUMENTACION</h6>
            <div class="table-responsive box-table">
              <table class="table">
                
                <tbody>
                  <tr v-for="(doc,indx) in row.docs" :key="indx">
                    <td><i :class="doc.classicon" style="font-size: 20px;"></i> <a style="color: #848080;" :href="doc.documentUrl" target="_blank"> {{ doc.document_name }}</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>

    <b-modal ref="modal-share" modal-class="modal-s1" hide-footer title="" centered no-close-on-backdrop no-close-on-esc>
      <h5 class="modal-title">COMPARTIR</h5>

      <div class="box-share">
        <div class="col col-text">
          https://extractoseum.online/#/coa/{{ row.id }}/{{ row.ide }}
        </div>

        <div class="col col-btn">
          <button type="button" class="btn" id="btn-copy" @click="copyButton()"><span id="txt-copy">Copiar</span> <i class="fal fa-copy"></i></button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="modal-qr" modal-class="modal-s1" hide-footer title="" centered no-close-on-backdrop no-close-on-esc>
      <h5 class="modal-title">CODIGO QR</h5>

      <div class="box-qr">
        <img :src="row.imageUrlQr">
      </div>
    </b-modal>

    <b-modal ref="modal-expired" modal-class="modal-s1" hide-footer title="" centered no-close-on-backdrop no-close-on-esc>
      <p>Le informamos que los certificados con más de 365 días de antigüedad pueden no reflejar resultados exactos debido al tiempo transcurrido.<br>Recomendamos obtener un nuevo análisis para asegurar la precisión de la información.</p>
      </b-modal>
      <sweet-modal blocking hide-close-button ref="modalloading">
      <div class="fa-3x" ><i class="fas fa-spinner fa-pulse"></i></div><br/>
      <div>Cargando ...</div>
    </sweet-modal>
  </div>
</template>

<script>
export default {
  data(){
    return{

      id: null,
      row:{
        details:[],
        stores:[],
      },

      // == Carousels options ==
      infoOptions: {
        slidesPerView: 3,
        spaceBetween: 5,

        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true,
        },

        breakpoints: {
          1300: {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          340: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }
      }
      // == ==
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        appendToast: true
      });
    },

    copyButton() {
      navigator.clipboard.writeText('https://extractoseum.online/#/coa/'+this.row.id+'/'+this.row.ide);

      document.getElementById("txt-copy").innerHTML="Copiado";
      document.getElementById('btn-copy').disabled = true;

      this.makeToast('success', 'Link copiado exitosamente', 'Compartir enlace');

      setTimeout(()=> {
        document.getElementById("txt-copy").innerHTML="Copiar";
        document.getElementById('btn-copy').disabled = false;
      }, 3000);
    },

    saveAction() {
   
      this.saveStadistic(2);
      setTimeout(() => {
        if(this.$root.logged == true){
          this.makeToast('success', 'Guardado exitosamente', 'Guardado');
          this.$router.push('/usuario/certificados-guardados?certificates_id='+this.id);
        }
        else{
          this.$router.push('/registrarse?certificates_id='+this.id);
        }
       
      }, 800);
    },
    getInfo(){
      this.$refs.modalloading.open();
      axios.get(tools.url('/api/certificate/'+this.id)).then((response)=>{
            this.row = response.data;
            if(this.row.expired == 1){
             
              this.$refs['modal-expired'].show();
            }
            this.saveStadistic(1);

            this.$refs.modalloading.close();
          }).catch((error)=>{
            this.$refs.modalloading.close();
        });

      
    },
    saveStadistic(type){
      var data = {
          id:this.id,
          type:type,
      };
      axios.post(tools.url('/api/certificateStadistics'),data).then((response)=>{
           
      });
    },
    openPdf(){
      this.saveStadistic(3);
      window.open(this.row.documentUrl,'_blank');
    },


  },
  mounted(){
    if(this.$route.params.id){
        this.id = this.$route.params.id;
        this.getInfo();
    }

  }
}
</script>
